// extracted by mini-css-extract-plugin
export default {"content":"decision_popover-module__content--3aL8n","chips":"decision_popover-module__chips--3ZVrj","chip":"decision_popover-module__chip--2-yDj"};